import React from "react";
import { Button } from "react-bootstrap";
import "./index.css";

const CustomButton = ({
  variant,
  type,
  size,
  onClick,
  disabled,
  className,
  label,
  style,
}) => {
  return (
    <Button
      variant={variant}
      type={type}
      size={size}
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={style}
    >
      {label}
    </Button>
  );
};

export default CustomButton;
